function polarToCartesian(offset, radius, angle) {
let x = Math.sin(angle) * radius + offset.x;
let y = -Math.cos(angle) * radius + offset.y;

return { x, y };
}


/**
 * @param {{ radius, center: number[], startAngle, endAngle }} options 
 * @returns 
 */
function getPath(options) {
    const { radius, center: _center, startAngle, endAngle } = options;

    const center = { x: _center[0], y: _center[1] };
    
    if(endAngle - startAngle >= Math.PI*2) {
        return `M ${center.x} ${center.y}
        m -${radius}, 0
        a ${radius},${radius} 0 1,0 ${radius*2},0
        a ${radius},${radius} 0 1,0 -${radius*2},0`;
    }

    const largeSweep = endAngle - startAngle >= Math.PI ? 1 : 0;
    const smallSweep = 1;

    const startPoint = polarToCartesian(center, radius, startAngle);
    const endPoint = polarToCartesian(center, radius, endAngle);

    return `M${center.x} ${center.y} ${startPoint.x} ${startPoint.y} A ${radius} ${radius} 0 ${largeSweep} ${smallSweep} ${endPoint.x} ${endPoint.y} Z`;
}


/**
 * 
 * @param {{
 *  radius: number,
 *  data: { label, value, style: { stroke: { color, width }, fillColor }, onHover, onClick }[]
 * }} param0 
 */
export function PieChart({ radius, data, className, center = [ 0, 0 ], height, width }) {
    let total = data.reduce((a, b) => a + b.value, 0);
    let currentAngle = 0;
    const fullAngle = Math.PI*2;


    return <svg className={className || ""} height={height} width={width}>
        {
            data.map((item, i) => {
                let { label, value, style, onClick, onHover, onHoverOut } = item;

                const fillColor = style?.fillColor || "#cccccc";
                const stroke = { width: style?.stroke?.width || 4, color: style?.stroke?.color || "#fff" };

                const fraction = value / total;
                const startAngle = currentAngle;
                const endAngle = (i === data.length - 1) ? fullAngle : (startAngle + fraction*fullAngle);

                const path = getPath({ radius, center, startAngle, endAngle });

                currentAngle = endAngle;

                return endAngle - startAngle ? <path key={i} d={path} onClick={onClick} onMouseMove={onHover} onMouseLeave={onHoverOut} fill={fillColor} stroke={stroke.color} strokeWidth={stroke.width} /> : null;
            }).filter(i => i)
        }
    </svg>;
}